// Module
var code = `<select show-errors id="block-input-{{block.id}}" class="form-control" ng-required="block.required" ng-model="answer.value" uib-tooltip="{{
    'Selecting an answer displays it as preselected on the registration form.'
      | translate
  }}" tooltip-enable="{{ isAdmin }}"> <option value="" translate>Choose one...</option> <option value="{{ ::choice.value }}" ng-repeat="choice in block.content.choices track by \$index" ng-if="choiceVisible(block, choice)" ng-selected="{{ choice.value === answer.value }}"> {{ ::visibleValues[\$index] }} </option> </select> `;
// Exports
var _module_exports =code;;
var path = '/scripts/directives/blocks/selectQuestion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;